import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=f80af27e"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports